// removed by extract-text-webpack-plugin
module.exports = {"portfolioWrapper":"_3GtspOaify2UjJ5GmrW-U8","title":"_2wjjo-9bVFdVw90wcZNNug"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Portfolio/Portfolio.scss
// module id = 1687
// module chunks = 0